import { createTypes, actionCreator } from 'redux-action-creator';
import { Action } from '../../../types';
import { Waiver } from '../../../../types/waiver';

export const types: { [key: string]: string } = createTypes(
  ['START', 'END'],
  'WORK_ITEM_CHANGE_WAIVER_ASSOCIATION',
);

export function startChangeWaiverAssociation(waiver: Waiver): Action<Waiver | null> {
  return {
    type: types.START,
    response: waiver,
  };
}

export const endChangeWaiverAssociation: () => Action<Waiver | null> = actionCreator(
  types.END,
);
